import React from 'react';
import { TextField, InputAdornment, SelectChangeEvent } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

interface CustomTextFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface CustomSelectProps {
    label: string;
    name: string;
    value: string;
    options: { label: string; value: string }[];
    onChange: (e: SelectChangeEvent<string>) => void;
  }
  

export const CustomTextField: React.FC<CustomTextFieldProps> = ({ label, name, value, onChange }) => {
  return (
    <TextField
      label={label}
      name={name}
      fullWidth
      margin="dense"
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {' '}
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          backgroundColor: 'white',
          '&:hover fieldset': {
            borderColor: '#ccc',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#039BE5',
          },
          paddingLeft: 0,
        },
        '& input': {
          padding: '10px 2px',
          color: '#666',
          fontSize: '14px',
          height: '23px',
        },
      }}
    />
  );
};

export const CustomSelectField: React.FC<CustomSelectProps> = ({ label, name, value, options, onChange }) => {
    return (
      <FormControl fullWidth margin="dense">
        <InputLabel shrink sx={{ background: '#ffffff', px: 0.5 }}>{label}</InputLabel>
        <Select
          name={name}
          value={value}
          onChange={onChange}
          sx={{
            borderRadius: '8px',
            backgroundColor: 'white',
            '& .MuiSelect-select': {
              padding: '10px',
              fontSize: '14px',
              color: '#666',
            },
            '&:hover fieldset': {
              borderColor: '#ccc',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#039BE5',
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

//       <CustomSelectField
//     label="Role"
//     name="role"
//     value={newUser.role}
//     onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
//     options={[
//         { label: 'Admin', value: 'admin' },
//         { label: 'Reader', value: 'reader' }
//     ]}
// />